import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { isMobile } from "../../utils/deviceCheck.js";
import styles from "./dashboard.module.css";

export default function Dashboard() {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // ⭐ form state (người dùng nhập)
  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    email: "",
    startDate: "",
  });

  // ⭐ filters thật sự để gọi API
  const [filters, setFilters] = useState({});

  const token = localStorage.getItem("admin_token");

  const fetchData = useCallback(async () => {
    const res = await axios.get(
      "https://duhochanquocnewlife.com/api/admin/consultations",
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, ...filters },
      }
    );

    setData(res.data.data);
    setTotalPages(res.data.totalPages);
  }, [filters, page, token]);

  // chỉ chạy khi page hoặc filters thay đổi
  useEffect(() => {
    if (isMobile()) {
      alert("Vui lòng đăng nhập trên máy tính để sử dụng");
      return;
    }

    fetchData();
  }, [fetchData]);

  // ⭐ chỉ search khi bấm nút
  const handleSearch = () => {
    setPage(1);
    setFilters(form);
  };

  return (
    <div className={styles.dashboard_container}>
      <h2>Danh sách đăng ký tư vấn</h2>

      {/* SEARCH */}
      <div className={styles.search}>
        <input
          placeholder="Họ tên"
          value={form.fullName}
          onChange={(e) =>
            setForm({ ...form, fullName: e.target.value })
          }
        />

        <input
          placeholder="SĐT"
          value={form.phone}
          onChange={(e) =>
            setForm({ ...form, phone: e.target.value })
          }
        />

        <input
          placeholder="Email"
          value={form.email}
          onChange={(e) =>
            setForm({ ...form, email: e.target.value })
          }
        />

        <input
          type="date"
          value={form.startDate}
          onChange={(e) =>
            setForm({ ...form, startDate: e.target.value })
          }
        />

        <button onClick={handleSearch}>Tìm kiếm</button>
      </div>

      {/* TABLE */}
      <table className={styles.dashboard_table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Họ tên</th>
            <th>SĐT</th>
            <th>Email</th>
            <th>Lời nhắn</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, i) => (
            <tr key={item._id}>
              <td>{(page - 1) * 10 + i + 1}</td>
              <td>{item.fullName}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              <td>{item.message}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className={styles.pagination}>
        <button style={{ cursor: `${page === 1 ? 'not-allowed' : 'pointer'}` }} disabled={page === 1} onClick={() => setPage(1)}>{"<<"}</button>

        <button style={{ cursor: `${page === 1 ? 'not-allowed' : 'pointer'}` }} disabled={page === 1} onClick={() => setPage(page - 1)}>{"<"}</button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={page === i + 1 ? styles.active_page : ""}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button style={{ cursor: `${page === totalPages ? 'not-allowed' : 'pointer'}` }} disabled={page === totalPages} onClick={() => setPage(page + 1)}>{">"}</button>

        <button style={{ cursor: `${page === totalPages ? 'not-allowed' : 'pointer'}` }} disabled={page === totalPages} onClick={() => setPage(totalPages)}>{">>"}</button>
      </div>

    </div>
  );
}
